import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AppService } from 'src/app/_services/app.service';
import { MaintenanceComponent } from '../maintenance.component';

@Component({
    selector: 'app-add-vendor',
    templateUrl: './add-vendor.component.html',
    styleUrls: ['./add-vendor.component.scss'],
    standalone: false
})
export class AddVendorComponent implements OnInit {

  displayColumns: string[] = ['market', 'delay', 'enabled'];
  publicationMarketsLength: number = 0;
  selectedVendor: Vendor;

  constructor(public service: AppService, public dialogRef: MatDialogRef<MaintenanceComponent>, @Inject(MAT_DIALOG_DATA) public data) { }

  ngOnInit() {
    this.InitializeSettings();
  }

  /** Initialize setting in the page */
  InitializeSettings() {
    this.selectedVendor = {
      id: this.data.id,
      name: this.data.name,
      enabled: this.data.enabled,
      publicationMarkets: this.data.publicationMarkets
    };
    this.publicationMarketsLength = this.selectedVendor.publicationMarkets.length;
  }

  /** Save event for the vendor */
  OnSaveVendor() {
    this.dialogRef.close(this.selectedVendor);
  }

  /** Cancel button event */
  OnCancel() {
    this.dialogRef.close(null);
  }

}

/** An interface to access vendor details */
interface Vendor {
  id: string;
  name: string;
  enabled: boolean;
  publicationMarkets: PublicationMarket[];
}

/** An inteface to access publication market details */
interface PublicationMarket {
  marketId: string;
  marketName: string;
  delay: number;
  enabled: boolean;
}
